<template>
  <div class="HomePage" ref="contentRef">
    <div style="width: 100%; height: 100%">
      <el-row style="height: 100%">
        <el-col :span="7" class="homeLeft">
          <div class="titleBox">
            <div class="boxStyle">
              <i class="iconfont icondidian"></i>
              <span class="titleCity">{{ weather.city }}</span>
              <span class="titleWeather">{{$t('HomPage.weather')}}</span>
              {{ weather.tem2 }}-{{ weather.tem1 }}℃
            </div>
          </div>
          <div class="upBox">
            <div class="leftUp">
              <div class="upAll">
                <div class="title">
                  <i class="iconfont iconsanjiaoright"></i>
                  <span class="title-name">{{$t('HomPage.dynamicStatistics')}}</span>
                  <span class="title-en">Vehicle type statistics</span>
                  <i class="iconfont iconargyle-copy"></i>
                </div>
                <div class="upFlex">
                  <div class="flexCar">
                    <img
                      src="../../assets/images/carTotal.png"
                      class="carImg"
                    />
                    <span class="carTitle">{{$t('HomPage.carCount')}}</span>
                    <span class="carNumber">{{ carCount }}</span>
                    <span class="carUnit">{{$t('HomPage.forklift')}}</span>
                  </div>
                  <div class="flexType">
                    <div class="typeHalf">
                      <img
                        src="../../assets/images/diesel .png"
                        class="halfImg"
                      />
                      <div class="halftxt">
                        <div class="txtTitle">{{$t('HomPage.dieselVehicle')}}</div>
                        <div class="txtNum">
                          {{ internalCombustionCarCount }}{{$t('HomPage.cars')}}
                        </div>
                      </div>
                    </div>
                    <div class="typeHalf">
                      <img
                        src="../../assets/images/electric.png"
                        class="halfImg"
                      />
                      <div class="halftxt">
                        <div class="txtTitle">{{$t('HomPage.electrocar')}}</div>
                        <div class="txtNum">{{ electricCarCount }}{{$t('HomPage.cars')}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="centerBox">
            <div class="leftUp">
              <div class="upAll">
                <div class="title">
                  <i class="iconfont iconsanjiaoright"></i>
                  <span class="title-name">{{$t('HomPage.AnnualAuditStatistics')}}</span>
                  <span class="title-en">Annual audit statistics</span>
                  <i class="iconfont iconargyle-copy"></i>
                </div>
                <div class="allEcharts">
                  <div
                    v-if="isTrial"
                    v-loading="trialLoading"
                    class="echartStyle"
                  >
                    <linegraph
                      ref="trialRef"
                      :id="'trialBargraph'"
                      :data="trialOption"
                      class="trialStyle"
                    ></linegraph>
                  </div>
                  <div class="halfNone" v-else>{{$t('common.noData')}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="downBox">
            <div class="leftDown">
              <div class="upAll">
                <div class="title">
                  <i class="iconfont iconsanjiaoright"></i
                  ><span class="title-name">{{$t('HomPage.carAgeRatio')}}</span>
                  <span class="title-en">Percentage of vehicle age</span>
                  <i class="iconfont iconargyle-copy"></i>
                </div>
                <div class="allEcharts">
                  <div v-if="isAge" v-loading="ageLoading" class="echartStyle">
                    <linegraph
                      :id="'ageBargraph'"
                      :data="ageOption"
                      class="trialStyle"
                    ></linegraph>
                  </div>
                  <div class="halfNone" v-else>{{$t('common.noData')}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="downBox">
            <div class="leftDown">
              <div class="upAll">
                <div class="title">
                  <i class="iconfont iconsanjiaoright"></i
                  ><span class="title-name">{{$t('HomPage.carryingCapacityStatistics')}}</span>
                  <span class="title-en">Bearing capacity statistics</span>
                  <i class="iconfont iconargyle-copy"></i>
                </div>
                <div class="allEcharts">
                  <div
                    v-if="isCapacity"
                    v-loading="capacityLoading"
                    class="echartStyle"
                  >
                    <linegraph
                      :id="'capacityBargraph'"
                      :data="capacityOption"
                      class="trialStyle"
                    ></linegraph>
                  </div>
                  <div class="halfNone" v-else>{{$t('common.noData')}}</div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="10" class="homeCenter">
          <div class="centerTitle">{{$t('HomPage.QingdaoMarketLogisticsEquipmentInformationPlatform')}}</div>
          <div class="centerFlex">
            <div class="flexHalf">
              <div class="halfNum">
                {{ workDayCount }}<span class="numUnit">{{$t('HomPage.day')}}</span>
              </div>
              <div class="halfTxt">{{$t('HomPage.SafeOperatingDaysOfTheDevice')}}</div>
            </div>
            <div class="flexHalf">
              <div class="halfNum">
                {{ workTimeSum }}<span class="numUnit">{{$t('HomPage.hour')}}</span>
              </div>
              <div class="halfTxt">{{$t('HomPage.CumulativeRunningTime')}}</div>
            </div>
          </div>
          <div class="allEcharts">
            <div class="centerBtn">
              <div
                class="btnStyle"
                v-for="(btn, index) in btnList"
                :key="index"
                @click="changeBtn(index)"
              >
                <el-button
                  :class="{ btnBackground: changeBackground === index }"
                  >{{ btn.name }}</el-button
                >
              </div>
            </div>
            <div v-if="isMap" v-loading="mapLoading" class="echartStyle">
              <linegraph
                :id="'mapBargraph'"
                :data="{ data }"
                class="trialStyle"
              ></linegraph>
            </div>
            <div class="halfNone" v-else>{{$t('common.noData')}}</div>
          </div>
        </el-col>
        <el-col :span="7" class="homeLeft">
          <div class="titleBox">
            <div class="boxRight">
              <div class="rightInfo">
                <i
                  :class="
                    this.iFullScreen
                      ? 'iconfont iconchuangkouhuanyuan'
                      : 'iconfont iconfangda'
                  "
                  :title="$t('HomPage.toggleFullScreen')"
                  @click="toggleFullScreen"
                >
                </i>
                <span class="titleBtn" @click="btnSys"
                  ><i class="iconfont iconicon-houtaiguanli"></i>{{$t('HomPage.backManagement')}}</span
                >
              </div>
              {{ date }}
            </div>
          </div>
          <div class="upBox">
            <div class="leftUp">
              <div class="upAll">
                <div class="title">
                  <i class="iconfont iconsanjiaoright"></i>
                  <span class="title-name">{{$t('HomPage.proportionOfNewRegulations')}}</span>
                  <span class="title-en"
                    >Proportion of compliance with new regulations</span
                  >
                  <i class="iconfont iconargyle-copy"></i>
                </div>
                <div class="upFlex">
                  <div class="flexCar flexRight">
                    <img
                      src="../../assets/images/insureTotal.png"
                      class="carImg"
                    />
                    <span class="carTitle">{{$t('HomPage.newRegulationsCount')}}</span>
                    <span class="carNumber">{{ newRegulationsCount }}</span>
                    <span class="carUnit">{{$t('HomPage.forklift')}}</span>
                  </div>
                  <div class="allEcharts">
                    <div
                      v-if="isInsure"
                      v-loading="insureLoading"
                      class="echartStyle"
                    >
                      <linegraph
                        :id="'insureBargraph'"
                        :data="insureOption"
                        class="trialStyle"
                      ></linegraph>
                    </div>
                    <div class="halfNone" v-else>{{$t('common.noData')}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="centerBox">
            <div class="leftUp">
              <div class="upAll">
                <div class="title">
                  <i class="iconfont iconsanjiaoright"></i>
                  <span class="title-name">{{$t('HomPage.insuranceCoverage')}}</span>
                  <span class="title-en">Insurance coverage</span>
                  <i class="iconfont iconargyle-copy"></i>
                </div>
                <div class="allEcharts">
                  <div
                    v-if="isNewRule"
                    v-loading="newRuleLoading"
                    class="echartStyle"
                  >
                    <linegraph
                      :id="'newRuleBargraph'"
                      :data="newRuleOption"
                      class="trialStyle"
                    ></linegraph>
                  </div>
                  <div class="halfNone" v-else>{{$t('common.noData')}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="downBox">
            <div class="leftDown">
              <div class="upAll">
                <div class="title">
                  <i class="iconfont iconsanjiaoright"></i
                  ><span class="title-name">{{$t('HomPage.sevenDayVehicleWorkingRate')}}</span>
                  <span class="title-en">Seven day vehicle working rate</span>
                  <i class="iconfont iconargyle-copy"></i>
                </div>
                <div class="allEcharts">
                  <div
                    v-if="isCarRate"
                    v-loading="carRateLoading"
                    class="echartStyle"
                  >
                    <linegraph
                      :id="'carRateBargraph'"
                      :data="carRateOption"
                      class="trialStyle"
                    ></linegraph>
                  </div>
                  <div class="halfNone" v-else>{{$t('common.noData')}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="downBox">
            <div class="leftDown">
              <div class="upAll">
                <div class="title">
                  <i class="iconfont iconsanjiaoright"></i
                  ><span class="title-name">{{$t('HomPage.sevenDayCheckPassRate')}}</span>
                  <span class="title-en"
                    >Qualified rate of 7-day spot check</span
                  >
                  <i class="iconfont iconargyle-copy"></i>
                </div>
                <div class="allEcharts">
                  <div
                    v-if="isCheck"
                    v-loading="checkLoading"
                    class="echartStyle"
                  >
                    <linegraph
                      :id="'checkBargraph'"
                      :data="checkOption"
                      class="trialStyle"
                    ></linegraph>
                  </div>
                  <div class="halfNone" v-else>{{$t('common.noData')}}</div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import HomePage from "./HomePage.js";
export default HomePage;
</script>

<style lang="less" scoped>
@import url("./HomePage.less");
</style>
